// Actions for MFA Verification
export const Types = {
  SUBMIT_MFA: 'MFAVerification/SUBMIT_MFA',
  SUBMIT_MFA_SUCCESS: 'MFAVerification/SUBMIT_MFA_SUCCESS',
  SUBMIT_MFA_FAIL: 'MFAVerification/SUBMIT_MFA_FAIL',
  RESET_MFA: 'MFAVerification/RESET_MFA',
};

export const submitMFA = (payload) => {
  return {
    type: Types.SUBMIT_MFA,
    payload,
  };
};

export const submitMFASuccess = (user) => ({
  type: Types.SUBMIT_MFA_SUCCESS,
  user,
});

export const submitMFAFail = (error) => ({
  type: Types.SUBMIT_MFA_FAIL,
  error,
});

export const resetMFA = () => ({
  type: Types.RESET_MFA,
});
